
fx.ns("shared.popups", class EnterPhoneSuccess extends fx.components.Popup{
    
    constructor()
    {
        super();

        this.contentWidth = 450;
        this.contentHeight = 370;
    }

    onReady()
    {
        super.onReady();

        this.on("click", this.close, this.okButton);
        this.on("ESCAPE", this.close, fx.keyboard);
    }

    create()
    {
        super.create();
 
        this.addChild(new shared.component.Person(fx.get("assets").personNice), {width:200, height : 200, top : -100, left : "center"});

        this.addChild(new fx.components.Text({text:fx.text("Vous allez recevoir un sms !"), className:"successtitle title center"}), {height:30, left:"center", top:120, width:"100%"});
        this.addChild(new fx.components.Text({text:fx.text("Cliquez sur le lien dans le SMS, et envoyez vos photos. Elles apparaîtront ensuite dans votre galerie photo ici."), className:"successtext text center"}),{top:180, left:"center", width:410});
        
        this.okButton = new fx.components.Button({label : fx.text("Fermer"), type : "filled"});
        this.addChild(this.okButton, {height:60, width : 200, top:285, left:"center"});
    }


});